import React from 'react'
import { useAppAction } from './useApp'
import { realtimeService } from 'src/services/realtime'

export const useOnlineState = ({ showToast }: { showToast?: boolean }) => {
  const [online, setOnline] = React.useState(true)
  const toast = useAppAction.tost()

  const handleOnline = () => {
    setOnline(true)
  }

  const handleOffline = () => {
    setOnline(false)
    if (showToast) {
      toast({
        type: 'error',
        title: 'Connection lost',
        description: 'Check your internet connection.',
      })
    }
  }

  React.useEffect(() => {
    window.addEventListener('offline', handleOffline)
    window.addEventListener('online', handleOnline)
    realtimeService.client?.connection.on('connected', handleOnline)
    realtimeService.client?.connection.on('disconnected', handleOffline)

    return () => {
      window.removeEventListener('offline', handleOffline)
      window.removeEventListener('online', handleOnline)
      realtimeService.client?.connection.off('connected', handleOnline)
      realtimeService.client?.connection.off('disconnected', handleOffline)
    }
  }, [])

  return online
}
